"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essRecordsFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const authored_evidence_1 = require("../../../composite/evidence/authored-evidence/authored-evidence");
const evidence_1 = require("../../../composite/evidence/evidence");
const records_fields_1 = require("./records-fields");
const records_columns_1 = require("./records-columns");
const lodash_1 = require("lodash");
function essRecordsFactory(url, reportTag) {
    return function Records() {
        const intl = react_intl_1.useIntl();
        const evidence = authored_evidence_1.useAuthoredEvidence({
            identifier: 'ESS_RECORDS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: records_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'ESS_RECORDS_TABLE_TITLE',
                    defaultMessage: 'Spisy',
                }),
                reportTag,
            },
            detailProps: {
                FieldsComponent: records_fields_1.RecordsFields,
                toolbarProps: {
                    showButton: lodash_1.stubFalse,
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.essRecordsFactory = essRecordsFactory;
//# sourceMappingURL=records.js.map